var productFormSelector = 'form[action*="cart/add"].product-buy-form-pdp';

function AIFU_ProductFormExists() {
    return document.querySelector(productFormSelector) !== null;
}

function AIFU_GetProductForm() {
    return document.querySelector(productFormSelector);
}

function AIFU_ProductFormHasQuantityBreakItems(form) {
    return !!(form && form.querySelector('.quantity-break-variant-form'));
}

// Returns the variant ID from the product form (input[name="id"]), if it exists.
function AIFU_GetProductFormVariantId() {
    var form = AIFU_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    return input && input.value ? input.value : null;
}

function AIFU_SetProductFormVariantId(variantId) {
    var form = AIFU_GetProductForm();
    if (!form) return false;
    var input = form.querySelector('input[name="id"]');
    if (!input && AIFU_ProductFormHasQuantityBreakItems(form)) return true;
    if (input) {
        input.value = variantId !== undefined && variantId !== null && variantId !== '' ? String(variantId) : '';
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

function AIFU_ProductFormSwitchToItemsMode(items, options) {
    var form = AIFU_GetProductForm();
    if (!form) return false;
    if (!items || !Array.isArray(items) || items.length === 0) return false;

    options = options || {};
    var containerClass = options.containerClass || 'product-form-items-container';
    var startIndex = options.startIndex !== undefined ? options.startIndex : 1;

    var existing = form.querySelector('.' + containerClass);
    if (existing) existing.remove();

    var singleItem = items.length === 1 ? items[0] : null;
    var hasLineItemProperties = singleItem && singleItem.properties && Object.keys(singleItem.properties).length > 0;

    if (singleItem && !hasLineItemProperties) {
        var singleIdInput = form.querySelector('input[name="id"]');
        if (!singleIdInput) {
            singleIdInput = document.createElement('input');
            singleIdInput.type = 'hidden';
            singleIdInput.name = 'id';
            singleIdInput.className = 'product-variant-id';
            form.appendChild(singleIdInput);
        }
        singleIdInput.value = String(singleItem.id);
        singleIdInput.removeAttribute('disabled');

        var singlePlanInput = form.querySelector('input[name="selling_plan"]');
        if (singleItem.selling_plan != null && singleItem.selling_plan !== '') {
            if (!singlePlanInput) {
                singlePlanInput = document.createElement('input');
                singlePlanInput.type = 'hidden';
                singlePlanInput.name = 'selling_plan';
                form.appendChild(singlePlanInput);
            }
            singlePlanInput.value = String(singleItem.selling_plan);
        }

        singleIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (singlePlanInput) singlePlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
    }

    var container = document.createElement('div');
    container.className = containerClass;

    items.forEach(function (item, i) {
        var index = startIndex + i;
        var idIn = document.createElement('input');
        idIn.type = 'hidden';
        idIn.name = 'items[' + index + '][id]';
        idIn.value = String(item.id);
        idIn.className = containerClass === 'quantity-break-variant-form' ? 'product-variant-quantity-break' : 'product-variant-id';
        container.appendChild(idIn);

        var qtyIn = document.createElement('input');
        qtyIn.type = 'hidden';
        qtyIn.name = 'items[' + index + '][quantity]';
        qtyIn.value = String(item.quantity != null ? item.quantity : 1);
        container.appendChild(qtyIn);

        if (item.selling_plan != null && item.selling_plan !== '') {
            var planIn = document.createElement('input');
            planIn.type = 'hidden';
            planIn.name = 'items[' + index + '][selling_plan]';
            planIn.value = String(item.selling_plan);
            container.appendChild(planIn);
        }

        if (item.properties && typeof item.properties === 'object') {
            Object.keys(item.properties).forEach(function (key) {
                var propIn = document.createElement('input');
                propIn.type = 'hidden';
                propIn.name = 'items[' + index + '][properties][' + key + ']';
                propIn.value = String(item.properties[key]);
                container.appendChild(propIn);
            });
        }
    });

    var mainIdInput = form.querySelector('input[name="id"]');
    if (mainIdInput) mainIdInput.remove();

    form.appendChild(container);
    return true;
}

function AIFU_ProductFormSwitchToSingleIdMode(variantId, itemsContainerSelector) {
    var form = AIFU_GetProductForm();
    if (!form) return false;

    if (itemsContainerSelector) {
        var container = form.querySelector(itemsContainerSelector);
        if (itemsContainerSelector === '.quantity-break-variant-form' && container) return true;
        if (container && (variantId === undefined || variantId === null || variantId === '')) {
            var firstIdInput = container.querySelector('input[name^="items["][name*="][id]"]');
            if (firstIdInput && firstIdInput.value) variantId = firstIdInput.value;
        }
        if (container) container.remove();
    }

    var input = form.querySelector('input[name="id"]');
    if (input) {
        if (variantId !== undefined && variantId !== null && variantId !== '') input.value = String(variantId);
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}
